<template src="./Filter.html"></template>
<style src="./Filter.css"></style>

<script>
import DataDetails from "@/components/ComandosValidacaoLog/DataDetails/DataDetails";
import Bar from "@/components/Charts/Bar/Bar";
import Line from "@/components/Charts/Line/Line";

import store from "@/store";
import { api } from "@/services/index";
import {
  loadComandosValidacaoLog,
  loadComandosValidacaoLogDataDetails,
  loadComandosValidacaoLogByReturns,
  loadComandosValidacaoLogByWeeks,
  loadComandosValidacaoLogByVersion
} from "@/services/modules/comandosValidacaoLog";

import * as GraficosService from "../../../providers/graficos.service";
import moment from "moment";
moment.locale("pt-BR");

export default {
  components: {
    "app-component-comandos-validacao-log-data-details": DataDetails,
    "app-component-charts-bar": Bar,
    "app-component-charts-line": Line
  },
  data() {
    var self = this;

    return {
      dateOne: new Date(moment().startOf("month")),
      dateTwo: new Date(moment().endOf("month")),
      byReturn: 3,
      pagination: { rowsPerPage: 30 },
      dataHeaders: [
        {
          text: "Validação",
          value: "COMVALDESCRICAO"
        },
        {
          text: "Com erros",
          value: "withError"
        },
        {
          text: "Sem retornos",
          value: "nonReturn"
        },
        {
          text: "Com retornos",
          value: "withReturn"
        },
        {
          text: "Total",
          value: "total"
        }
      ],
      chartByErrorsOptions: {
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: "#e7e7e7",
              strokeWidth: "100%",
              margin: 0, // margin is in pixels
              shadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: "#999",
                opacity: 1,
                blur: 2
              }
            }
          }
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            shadeIntensity: 0.4,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 53, 91]
          }
        },
        expandOnClick: false,
        labels: ["Com erros", "Sem retornos", "Com retornos"],
        colors: ["#2A5377", "#88C658", "#53856a"],
        legend: {
          position: "left"
        },
        chart: {
          events: {
            dataPointSelection: function(event, chartContext, config) {
              self.selectByErrors(event, chartContext, config);
            },
            legendClick: function(chartContext, seriesIndex, config) {
              config.dataPointIndex = seriesIndex;
              self.selectByErrors(event, chartContext, config);
            }
          }
        }
      }
    };
  },
  created() {
    this.executeAllFilter();
  },
  methods: {
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = `${moment(dateOne).format("DD")} ${moment(
          dateOne
        ).format("MMMM")}`;
      }
      if (dateTwo) {
        formattedDates += ` até ${moment(dateTwo).format("DD")} ${moment(
          dateTwo
        ).format("MMMM")}`;
      }
      return formattedDates;
    },
    getDateFilter() {
      if (this.dateOne == "" && this.dateTwo == "") return {};

      let initialDate = null;
      let finalDate = null;
      if (this.dateOne != null && this.dateOne != "")
        initialDate = moment(this.dateOne).format("YYYY-MM-DD");
      if (this.dateTwo != null && this.dateTwo != "")
        finalDate = moment(this.dateTwo).format("YYYY-MM-DD");

      return {
        comValLogDataIni: initialDate,
        comValLogDataFim: finalDate
      };
    },
    applyDateFilter() {
      this.executeAllFilter();
    },
    cancelDateFilter() {
      this.dateOne = new Date(moment().startOf("month"));
      this.dateTwo = new Date(moment().endOf("month"));
      this.byReturn = 3;

      this.executeAllFilter();
    },
    selectByErrors(event, chartContext, config) {
      this.byReturn = 3;

      if (config.selectedDataPoints[0][0] == 0) this.byReturn = -1;
      else if (config.selectedDataPoints[0][0] == 1) this.byReturn = 0;
      else if (config.selectedDataPoints[0][0] == 2) this.byReturn = 1;

      this.executeByReturnFilter();
    },
    executeAllFilter() {
      const dateFilter = this.getDateFilter();

      loadComandosValidacaoLog({ ...dateFilter, byReturn: this.byReturn });
      loadComandosValidacaoLogByReturns({ ...dateFilter });
      loadComandosValidacaoLogByWeeks({
        ...dateFilter,
        byReturn: this.byReturn
      });
      loadComandosValidacaoLogByVersion({
        ...dateFilter,
        byReturn: this.byReturn
      });
    },
    executeDataFilter() {
      const dateFilter = this.getDateFilter();

      loadComandosValidacaoLog({ ...dateFilter, byReturn: this.byReturn });
    },
    executeByReturnFilter() {
      const dateFilter = this.getDateFilter();

      loadComandosValidacaoLog({ ...dateFilter, byReturn: this.byReturn });
      loadComandosValidacaoLogByWeeks({
        ...dateFilter,
        byReturn: this.byReturn
      });
      loadComandosValidacaoLogByVersion({
        ...dateFilter,
        byReturn: this.byReturn
      });
    },
    dataPointSelection(event, chartContext, config) {
      const dateFilter = this.getDateFilter();

      this.byReturn = config.seriesIndex == 0 ? 1 : 0;
      const week = this.byWeeks[config.dataPointIndex].week;

      loadComandosValidacaoLog({
        ...dateFilter,
        byReturn: this.byReturn,
        week
      });
    },
    expandDetail(_data, _comValID) {
      _data.expanded = !_data.expanded;

      if (_data.expanded) {
        let loadDetails = true;
        store.state.comandosValidacaoLog.dataDetails.forEach(details => {
          if (details.length > 0)
            if (details[0].COMVALID == _comValID) loadDetails = false;
        });

        if (loadDetails) {
          const dateFilter = this.getDateFilter();

          loadComandosValidacaoLogDataDetails(_comValID, {
            ...dateFilter,
            byReturn: this.byReturn
          });
        }
      }
    }
  },
  computed: {
    isXs() {
      return store.state.window.isXs;
    },
    windowWidth() {
      return store.state.window.width;
    },
    data() {
      return store.state.comandosValidacaoLog.data;
    },
    loadingData() {
      return store.state.comandosValidacaoLog.loadingData;
    },
    byReturns() {
      const withErrCount = Number(
        store.state.comandosValidacaoLog.byReturns[0]
      );
      const nonReturnCount = Number(
        store.state.comandosValidacaoLog.byReturns[1]
      );
      const withReturnCount = Number(
        store.state.comandosValidacaoLog.byReturns[2]
      );
      const total = withErrCount + nonReturnCount + withReturnCount;

      const percentWithErrCount = Math.round(
        (withErrCount * 100) / total
      ).toFixed(2);
      const percentNonReturnCount = Math.round(
        (nonReturnCount * 100) / total
      ).toFixed(2);
      const percentWithReturnCount = Math.round(
        (withReturnCount * 100) / total
      ).toFixed(2);

      return [
        percentWithErrCount,
        percentNonReturnCount,
        percentWithReturnCount
      ];
    },
    loadingByReturns() {
      return store.state.comandosValidacaoLog.loadingByReturns;
    },
    byWeeks() {
      return store.state.comandosValidacaoLog.byWeeks;
    },
    loadingByWeeks() {
      return store.state.comandosValidacaoLog.loadingByWeeks;
    },
    byVersions() {
      return store.state.comandosValidacaoLog.byVersions;
    },
    loadingByVersions() {
      return store.state.comandosValidacaoLog.loadingByVersions;
    },
    dataByWeeks() {
      if (store.state.comandosValidacaoLog.byWeeks == null)
        return {
          series: [],
          categories: []
        };

      const dataByWeeks = {
        series: store.state.comandosValidacaoLog.byWeeks.series,
        categories: store.state.comandosValidacaoLog.byWeeks.categories
      };
      return dataByWeeks;
    },
    dataByVersions() {
      if (store.state.comandosValidacaoLog.byVersions == null)
        return {
          series: [],
          categories: []
        };

      const dataByVersions = {
        series: store.state.comandosValidacaoLog.byVersions.series,
        categories: store.state.comandosValidacaoLog.byVersions.categories
      };
      return dataByVersions;
    }
  }
};
</script>